import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import "./app/styles/index.css";

/**
 * Без единственного слушателя касания Safari (а значит и WebView Telegram на
 * iOS) не применяет `:active` к элементам, кроме нативных кнопок и ссылок, —
 * поведение старое и недокументированное. На нём держится весь отклик на
 * нажатие из слоя движения (утилиты `press` и `press-row`, FE-13), поэтому
 * слушатель ставится один раз на документ и ничего не делает.
 */
document.addEventListener("touchstart", () => undefined, { passive: true });

const container = document.getElementById("root");
if (!container) throw new Error("#root не найден в index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
